module.exports = __webpack_public_path__ + "static/media/Capacidad-alta.568f302f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/contentassets/Capacidad-alta.svg
// module id = 149
// module chunks = 0